import React from "react";
import "./NewCreativeModal.css";

// The header and the primary button shared by the new and edit creative modals.
export function CreativeModalHeader({ eyebrow, title, titleId, onClose, closeDisabled }) {
  return (
    <div style={{ padding:"28px 28px 20px", borderBottom:"1px solid #F0F0F0" }}>
      <button onClick={onClose} disabled={closeDisabled} aria-label="Close" className="ncm-close" style={{ position:"absolute", top:12, right:14, width:32, height:32, background:"none", border:"none", color:"#626262", fontSize:18, cursor: closeDisabled ? "default" : "pointer", opacity: closeDisabled ? 0.4 : 1 }}>✕</button>
      <div style={{ fontSize:11, color:"#7b7b7b", letterSpacing:1, textTransform:"uppercase", marginBottom:6 }}>{eyebrow}</div>
      <h2 id={titleId} style={{ fontSize:20, fontWeight:600, color:"#151515", margin:0, fontFamily:"'Clash Display Variable','Clash Display',sans-serif" }}>{title}</h2>
    </div>
  );
}

// Busy keeps the magenta and runs the light band: the save is moving, not disabled.
export function CreativePrimaryButton({ onClick, disabled, busy, children }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      aria-busy={busy}
      className={busy ? "ncm-primary ncm-primary--busy" : "ncm-primary"}
      style={{ width:"100%", padding:"13px 0", background: busy ? "#F90091" : disabled ? "#E2E2E2" : "#F90091", color: busy ? "#fff" : disabled ? "#B8B8B8" : "#fff", border:"none", borderRadius:10, fontSize:14, fontWeight:600, cursor: busy ? "progress" : disabled ? "default" : "pointer" }}>
      {children}
    </button>
  );
}
